import React from 'react';
import TableHeader from './TableHeader';
import TableContent from './TableContent';
import { IModal } from '../../Editor/IEditor';

interface TableProps {
  modal: IModal;
  setModal: React.Dispatch<React.SetStateAction<IModal>>;
}

const Table = ({ modal, setModal }: TableProps) => {
  return (
    <table id="sessions_table" style={{ overflowX: 'scroll', tableLayout: 'fixed' }}>
      <TableHeader />
      <TableContent modal={modal} setModal={setModal} />
    </table>
  );
};

export default Table;
